module.exports = __webpack_public_path__ + "static/media/pp-poster.1fc040bc.png";